// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { styledScrollbar } from "@rc/App/SharedStyles/sharedStyles";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    ...productListFilterAccordionSectionStyles.accordionSection,
    panelProps: {
        css: css`
            padding: 12px 0;
            position: relative;
            .show-opacity {
                &::after {
                    content: '';
                    position: absolute;
                    bottom: 13px;
                    left: 0;
                    background: linear-gradient(to bottom, transparent, white);
                    height: 30px;
                    width: 90%;
                    pointer-events: none;
                }
            }
            .wrapper {
                overflow-y: auto;
                overflow-x: hidden;
                max-height: 190px;
                margin-right: 10px;
                margin-left: 10px;
                ${styledScrollbar(8, "secondary", 2, "common.ui2")};
            }
        `,
    },
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        &:not(:last-child) {
            padding-bottom: 10px;
        }
    `,
};
